import React from "react";
import Apple from "@/app/assets/icons/apple";
import GooglePlay from "@/app/assets/icons/googleplay";
import Close from "@/app/assets/icons/close";
import { handleAppDownload } from "@/app/utils/helper";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import { ICM_NAME_FULL } from "@/app/utils/constants";

interface FdAppDrawerProps {
    isOpen: boolean;
    onClose: () => void;
}

function FdAppDrawer({ isOpen, onClose }: FdAppDrawerProps) {
    return (
        <>
            {isOpen && (
                <div
                    id="app-download-overlay"
                    className="bg-black/50 fixed inset-0 z-40 backdrop-blur-md md:hidden"
                    onClick={onClose}
                />
            )}
            <div
                id="app-download-modal"
                className={`fixed bottom-0 left-0 right-0 z-50 w-full transition-transform duration-300 ease-in-out sm:block md:hidden ${isOpen ? "translate-y-0" : "translate-y-full"} rounded-t-xl bg-white shadow-lg`}
            >
                <div id="app-download-content" className="px-s9 py-s13 shadow-sm">
                    <div
                        id="app-download-header"
                        className="z-50 mb-8 flex items-center justify-between"
                    >
                        <p
                            id="app-download-title"
                            className="w-full text-center text-lg font-semibold leading-[130%] text-neutral-900"
                        >
                            Get the {ICM_NAME_FULL} app
                        </p>
                        <Close id="app-download-close-btn" onClick={onClose} size={28} />
                    </div>

                    <div id="app-download-buttons" className="flex flex-col space-y-4">
                        <RegularButton
                            id="ios-download-btn"
                            icon={<Apple />}
                            showRightIcon={false}
                            size={ButtonSize.Large}
                            variant={ButtonVariant.SecondaryDefault}
                            className="w-full min-w-full bg-white"
                            label={"iOS"}
                            onClick={handleAppDownload}
                        />
                        <RegularButton
                            id="android-download-btn"
                            icon={<GooglePlay />}
                            showRightIcon={false}
                            size={ButtonSize.Large}
                            variant={ButtonVariant.SecondaryDefault}
                            className="!mt-4 w-full min-w-full bg-white"
                            label={"Android"}
                            onClick={handleAppDownload}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default FdAppDrawer;
